import { useMemo } from "react";
import LoyaltyListRewardsRedesign from "components/organisms/LoyaltyListRewardsRedesign";
import { useSelector } from "react-redux";
import { useAssignCashback } from "queries/useAssignCashback";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { Loyalty } from "types/Loyalty";
import { useGetLoyaltyRewardsUser } from "queries/useGetLoyaltyRewardsUser";
import { useGetRewardsInfo } from "queries/useGetRewardsInfo";
import { useLoyaltyRewardAssign } from "queries/useLoyaltyRewardAssign";
import { useGetCashbackInfo } from "queries/useGetCashbackInfo";
import { formatLoyaltyRewardsUser } from "utils/loyalty-rewards";
import * as userSelectors from "../../redux/user/selectors";
import { useGetProgressLoyalty } from "../../queries/useGetProgressLoyalty";
import { useGetGamesByIds } from "../../queries/useGetGamesByIds";

export const LoyaltyListRewardsRedesignContainer = () => {
  const { data } = useGetLoyaltyUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loyalty = data?.data?.data || ({} as Loyalty);
  const { userRewards, isLoading } = useGetLoyaltyRewardsUser({
    loyaltyId: loyalty?.id,
  });
  const currency = useSelector(userSelectors.currentCurrency);
  const idsRewards =
    userRewards
      .filter((r) => r.status === "available")
      .map((reward) => reward.rewardId) || [];
  const { rewardsInfo, isLoading: isLoadingRewards } =
    useGetRewardsInfo(idsRewards);
  const freeSpinsGamesIds = rewardsInfo
    ?.filter((r) => "rewardFreeSpin" in r)
    ?.map((r) => r.rewardFreeSpin.freeSpinsGame);
  const uniqueGamesIds = Array.from(new Set(freeSpinsGamesIds));
  const { games: gamesFreeSpins } = useGetGamesByIds(
    uniqueGamesIds,
    uniqueGamesIds.length > 0,
  );
  const { handleAssignReward, isPending } = useLoyaltyRewardAssign(
    loyalty.id || "",
  );
  const { handleAssignCashback } = useAssignCashback();
  const { cashbackDaily, cashbackWeekly, cashbackMonthly, isLoadingCashback } =
    useGetCashbackInfo();
  const { data: progressData, isLoading: isLoadingProgress } =
    useGetProgressLoyalty();
  const userExperience = progressData?.data?.data?.experience || 0;

  const rewards = useMemo(
    () =>
      formatLoyaltyRewardsUser({
        loyalty,
        currency,
        userRewards,
        freeSpinsGames: gamesFreeSpins,
        infoRewards: rewardsInfo,
        dailyCashback: cashbackDaily,
        monthlyCashback: cashbackMonthly,
        weeklyCashback: cashbackWeekly,
        assignReward: handleAssignReward,
        assignCashback: handleAssignCashback,
      }),
    [
      cashbackDaily,
      cashbackMonthly,
      cashbackWeekly,
      currency,
      gamesFreeSpins,
      handleAssignCashback,
      handleAssignReward,
      loyalty,
      rewardsInfo,
      userRewards,
    ],
  );

  return userExperience !== 0 ? (
    <LoyaltyListRewardsRedesign
      {...rewards}
      isLoading={
        isLoading ||
        isPending ||
        isLoadingProgress ||
        isLoadingCashback ||
        isLoadingRewards
      }
    />
  ) : null;
};
